<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow' : visible}"
    :style="visible ? 'display:block;': ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>Iniciar Ticket</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="handleCloseModal">
          <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body text-center mt-4">
            <span class="material-icons text-blue-2" style="font-size: 77px"> support_agent </span>
          <h5 class="modal-title">¿Estás seguro de iniciar el reclamo? El equipo de TreidBlue leerá la conversación y resolverá el problema.</h5>
          
        </div>
        <div class="p-3 text-center">
          <span class="btn btn-secondary mr-2" @click="handleCloseModal">Cancelar</span>
          <span v-if="!load" class="btn btn-treid" @click="handleClickSend">Si, deseo empezar el reclamo</span>
          <span v-else class="btn btn-treid"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cargando...</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalConfirmTicket",
  props: {
    visible: Boolean,
    load: Boolean
  },
  methods: {
    handleCloseModal(){
      this.$emit('close')
    },
    handleClickSend(){
      this.$emit('accept')
    },
  }
};
</script>
<style lang="css" scoped>
</style>